import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { TextQuestion, } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";

import { OrgLevel } from "@teamprevent/common/questionnaires/model";

import { furtherDetailsSectionId } from "../GenericCaseForm";

interface Props {
    questionConfigs: QuestionConfig[];
    orgLevels: OrgLevel[];
    selectedOrgStructureLevelIds: string[];
    readonly: boolean;
    changeOrgStructureLevel(level: number, selectedId: string): void;
    getQuestionMandatoryConfig(questionId: string, defaultValue: boolean): boolean;
}

export const EmployeeDetailsContinuedSection: React.FunctionComponent<Props> = (
    {
        questionConfigs,
        orgLevels,
        selectedOrgStructureLevelIds,
        readonly,
        changeOrgStructureLevel,
        getQuestionMandatoryConfig
    }) => {

    return (
        <ContextAwareProgressBarQuestionnaireSection title="Employee Details Cont'd" id={furtherDetailsSectionId}>
            <DropdownQuestion
                questionConfig={({ ...getQuestionConfig(questionConfigs, questionIds.OrgLevel1Name), id: questionIds.OrgLevel1Id })}
                options={orgLevels &&
                orgLevels.filter(orgLevel => !orgLevel.parentId)
                    .map(orgLevel => ({ text: orgLevel.name, value: orgLevel.id }))}
                // eslint-disable-next-line react/jsx-no-bind
                onAnswerChange={orgStructureId => changeOrgStructureLevel(0, orgStructureId as string)}
                search
                readonly={readonly}
                hidden={readonly}
                hideDivider
                mandatory
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.OrgLevel1Name)}
                hidden={!readonly}
                readonly
                hideDivider
            />
            <DropdownQuestion
                questionConfig={({ ...getQuestionConfig(questionConfigs, questionIds.OrgLevel2Name), id: questionIds.OrgLevel2Id })}
                options={(orgLevels && selectedOrgStructureLevelIds[0]) ?
                    orgLevels.filter(orgLevel => orgLevel.parentId === selectedOrgStructureLevelIds[0])
                        .map(orgLevel => ({ text: orgLevel.name, value: orgLevel.id })) : undefined}
                // eslint-disable-next-line react/jsx-no-bind
                onAnswerChange={orgStructureId => changeOrgStructureLevel(1, orgStructureId as string)}
                search
                readonly={readonly}
                hidden={!selectedOrgStructureLevelIds[0]}
                mandatory={getQuestionMandatoryConfig(questionIds.OrgLevel2Name, false)}
                hideDivider
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.OrgLevel2Name)}
                hidden={!readonly}
                readonly
                hideDivider
            />
            <DropdownQuestion
                questionConfig={({ ...getQuestionConfig(questionConfigs, questionIds.OrgLevel3Name), id: questionIds.OrgLevel3Id })}
                options={(orgLevels && selectedOrgStructureLevelIds[1]) ?
                    orgLevels.filter(orgLevel => orgLevel.parentId === selectedOrgStructureLevelIds[1])
                        .map(orgLevel => ({ text: orgLevel.name, value: orgLevel.id })) : undefined}
                // eslint-disable-next-line react/jsx-no-bind
                onAnswerChange={orgStructureId => changeOrgStructureLevel(2, orgStructureId as string)}
                search
                readonly={readonly}
                hidden={!selectedOrgStructureLevelIds[1]}
                mandatory={getQuestionMandatoryConfig(questionIds.OrgLevel3Name, false)}
                hideDivider
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.OrgLevel3Name)}
                hidden={!readonly}
                readonly
                hideDivider
            />
            <DropdownQuestion
                questionConfig={({ ...getQuestionConfig(questionConfigs, questionIds.OrgLevel4Name), id: questionIds.OrgLevel4Id })}
                options={(orgLevels && selectedOrgStructureLevelIds[2]) ?
                    orgLevels.filter(orgLevel => orgLevel.parentId === selectedOrgStructureLevelIds[2])
                        .map(orgLevel => ({ text: orgLevel.name, value: orgLevel.id })) : undefined}
                // eslint-disable-next-line react/jsx-no-bind
                onAnswerChange={orgStructureId => changeOrgStructureLevel(3, orgStructureId as string)}
                search
                readonly={readonly}
                hidden={!selectedOrgStructureLevelIds[2]}
                hideDivider
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.OrgLevel4Name)}
                hidden={!readonly}
                readonly
                hideDivider
            />
            <TextQuestion hideDivider questionConfig={getQuestionConfig(questionConfigs, questionIds.ShiftPattern)} readonly={readonly} />
            <TextQuestion hideDivider questionConfig={getQuestionConfig(questionConfigs, questionIds.StandardHours)} readonly={readonly} />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
